import { useSyncExternalStore } from 'react';

import { MEDIA } from './breakpoints.ts';

function matches(query: string): boolean {
	return typeof window !== 'undefined' && window.matchMedia?.(query).matches === true;
}

/** Whether `query` matches, kept current as the window changes (right from the first render). */
export function useMedia(query: string): boolean {
	return useSyncExternalStore(
		(onChange) => {
			const m = typeof window !== 'undefined' ? window.matchMedia?.(query) : undefined;
			m?.addEventListener?.('change', onChange);
			return () => m?.removeEventListener?.('change', onChange);
		},
		() => matches(query),
		() => false,
	);
}

/**
 * The game's layout tier (J3, tokens.css): `wide` (two columns, with a mouse), `tablet` (a
 * wider one-column game), or `undefined` on a phone, upright or on its side.
 */
export type GameLayout = 'wide' | 'tablet' | undefined;

export function useGameLayout(): GameLayout {
	const wide = useMedia(MEDIA.gameWide);
	const tablet = useMedia(MEDIA.gameTablet);
	return wide ? 'wide' : tablet ? 'tablet' : undefined;
}
